import {
  CardTitle,
  CardDescription,
  CardHeader,
  CardContent,
  CardFooter,
  Card,
} from "../../../components/ui/card";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { Textarea } from "../../../components/ui/textarea";
import { Button } from "../../../components/ui/button";
import {
  PopoverTrigger,
  PopoverContent,
  Popover,
} from "../../../components/ui/popover";
import { Calendar } from "../../../components/ui/calendar";
import { useEffect, useState } from "react";
import { format, set } from "date-fns";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { CreateTripDto } from "./CreateTripDto";
import { Toaster } from "../../../components/ui/toaster";
import SvgHtmlPassing from "../../../components/functions/SvgHtmlPassing";

const AdminCreateTripView = ({
  showLoader,
  existingTripDto,
  influencers,
  svgList,
  onSaveTripClicked,
}) => {
  const [createTripDto, setCreateTripDto] = useState(CreateTripDto.create());

  const canShowCloneButton = existingTripDto != null;
  const saveButtonLabel = existingTripDto ? "Save Trip" : "Create Trip";

  const [price, setPrice] = useState(0);
  const [bookingAmount,setBookingAmount]=useState(0);
  const [cardImg, setCardImg] = useState("");
  const [tripDetailBgImg, setTripDetailBgImg] = useState("");
  const [mobileTripDetailBgImg, setMobileTripDetailBgImg] = useState([]);
  const [tripCategory, setTripCategory] = useState("");
  const [tripCategoryImg, setTripCategoryImg] = useState("");
  const [vacancy, setVacancy] = useState("");
  const [vacancyBackground, setVacancyBackground] = useState("");
  const [tripName, setTripName] = useState("");
  const [tripIdAlias, setTripIdAlias] = useState("");
  const [tripTitleLine, setTripTitleLine] = useState("");
  const [tripPriceLine, setTripPriceLine] = useState("");
  const [curatorLine, setCuratorLine] = useState("");
  const [curatorImg, setCuratorImg] = useState("");
  const [curatorBgImg, setCuratorBgImg] = useState("");
  const [refundPolicyImg, setRefundPolicyImg] = useState("");
  const [tripDescription, setTripDescription] = useState("");
  const [tripStatus, setTripStatus] = useState("live");
  const [tags, setTags] = useState([]);
  const [inclusions, setInclusions] = useState([]);
  const [exclusions, setExclusions] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [quickDetails, setQuickDetails] = useState([]);
  const [itinerary, setItinerary] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedInfluencer, setSelectedInfluencer] = useState({
    key: "",
    value: "",
  });
  const [tripOverview, setTripOverview] = useState([]);
  const [tripStays, setTripStays] = useState([]);
  const [vibeGallery, setVibeGallery] = useState([]);
  const [uniqueness, setUniqueness] = useState([]);
  const [location, setLocation] = useState("");

  useEffect(() => {
    setPrice(existingTripDto?.price);
    setBookingAmount(existingTripDto?.bookingAmount);
    setCardImg(existingTripDto?.cardImg || "");
    setTripDetailBgImg(existingTripDto?.tripDetailBgImg || "");
    setMobileTripDetailBgImg(existingTripDto?.mobileTripDetailBgImg || []);
    setTripCategory(existingTripDto?.tripCategory || "");
    setTripCategoryImg(existingTripDto?.tripCategoryImg || "");
    setVacancy(existingTripDto?.vacancy || "");
    setVacancyBackground(existingTripDto?.vacancyBackground || "");
    setTripName(existingTripDto?.tripName || "");
    setTripIdAlias(existingTripDto?.tripIdAlias || "");
    setTripTitleLine(existingTripDto?.tripTitleLine || "");
    setTripPriceLine(existingTripDto?.tripPriceLine || "");
    setCuratorLine(existingTripDto?.curatorLine || "");
    setCuratorImg(existingTripDto?.curatorImg || "");
    setCuratorBgImg(existingTripDto?.curatorBgImg || "");
    setRefundPolicyImg(existingTripDto?.refundPolicyImg || "");
    setTripDescription(existingTripDto?.tripDescription || "");
    setTripStatus(existingTripDto?.status || "live");
    setTags(existingTripDto?.tags || []);
    setInclusions(existingTripDto?.inclusions || []);
    setExclusions(existingTripDto?.exclusions || []);
    setGallery(existingTripDto?.gallery || []);
    setQuickDetails(existingTripDto?.quickDetails || []);
    setItinerary(existingTripDto?.itinerary || []);
    setSelectedDates(existingTripDto?.tripDates || []);
    setTripOverview(existingTripDto?.tripOverview || []);
    setTripStays(existingTripDto?.tripStays || []);
    setVibeGallery(existingTripDto?.vibeGallery || []);
    setUniqueness(existingTripDto?.uniqueness || []);
    setLocation(existingTripDto?.location || "");
    const influencer = existingTripDto?.user?.id
      ? {
          key: existingTripDto?.user?.id,
          value: existingTripDto?.user.fullName,
        }
      : {};
    setSelectedInfluencer(influencer);
  }, [existingTripDto]);

  useEffect(() => {
    const tripDto = CreateTripDto.create({
      id: existingTripDto?.id || "",
      influencerId: selectedInfluencer.key,
      tags: tags,
      inclusions: inclusions,
      exclusions: exclusions,
      tripDescription: tripDescription,
      status: tripStatus,
      price: price,
      bookingAmount:bookingAmount,
      cardImg: cardImg,
      tripDetailBgImg: tripDetailBgImg,
      mobileTripDetailBgImg: mobileTripDetailBgImg,
      tripCategory: tripCategory,
      tripCategoryImg: tripCategoryImg,
      vacancy: vacancy,
      vacancyBackground: vacancyBackground,
      tripName: tripName,
      tripIdAlias: tripIdAlias,
      tripTitleLine: tripTitleLine,
      tripPriceLine: tripPriceLine,
      curatorLine: curatorLine,
      curatorImg: curatorImg,
      curatorBgImg: curatorBgImg,
      gallery: gallery,
      tripDates: selectedDates,
      refundPolicyImg: refundPolicyImg,
      quickDetails: quickDetails.map((detail) => ({
        itemTitle: detail.itemTitle,
        itemDesc: detail.itemDesc,
        itemImg: detail.itemImg,
      })),
      itinerary: itinerary.map((item) => ({
        heading: item.heading,
        desc: item.desc,
        img: item.img,
      })),
      tripOverview: tripOverview?.map((overview) => ({
        svgIcon: overview.svgIcon,
        svgHeading: overview.svgHeading,
        svgDesc: overview.svgDesc,
      })),
      tripStays: tripStays.map((stay) => ({
        stayImg: stay.stayImg,
        stayName: stay.stayName,
        stayDesc: stay.stayDesc,
      })),
      vibeGallery: vibeGallery,
      uniqueness: uniqueness.map((unique) => ({
        svgIcon: unique.svgIcon,
        heading: unique.heading,
      })),
      location: location,
    });

    setCreateTripDto(tripDto);
  }, [
    existingTripDto,
    price,
    bookingAmount,
    cardImg,
    tripDetailBgImg,
    mobileTripDetailBgImg,
    tripCategory,
    tripCategoryImg,
    vacancy,
    vacancyBackground,
    tripName,
    tripIdAlias,
    tripTitleLine,
    tripPriceLine,
    curatorLine,
    curatorImg,
    curatorBgImg,
    refundPolicyImg,
    tripDescription,
    tripStatus,
    tags,
    inclusions,
    exclusions,
    gallery,
    quickDetails,
    itinerary,
    selectedDates,
    selectedInfluencer,
    tripOverview,
    tripStays,
    vibeGallery,
    uniqueness,
    location,
  ]);

  const handleAddTag = () => {
    setTags([...tags, ""]);
  };

  const handleAddInclusion = () => {
    setInclusions([...inclusions, ""]);
  };

  const handleAddExclusion = () => {
    setExclusions([...exclusions, ""]);
  };

  const handleAddGalleryImage = () => {
    setGallery([...gallery, ""]);
  };

  const handleAddQuickDetail = () => {
    setQuickDetails([
      ...quickDetails,
      { itemTitle: "", itemDesc: "", itemImg: "" },
    ]);
  };

  const handleAddItineraryItem = () => {
    setItinerary([...itinerary, { heading: "", desc: [], img: "" }]);
  };

  const handleAddNewDate = () => {
    var to = new Date();
    to.setDate(to.getDate() + 3);
    setSelectedDates([
      ...selectedDates,
      { from: new Date(), to: to, tripTitleLine: "" },
    ]);
  };

  const handleAddNewTripOverview = () => {
    setTripOverview([
      ...tripOverview,
      { svgIcon: "", svgHeading: "", svgDesc: "" },
    ]);
  };

  const handleAddNewTripStays = () => {
    setTripStays([...tripStays, { stayImg: "", stayName: "", stayDesc: "" }]);
  };

  const handleAddNewVibeGallery = () => {
    setVibeGallery([...vibeGallery, ""]);
  };

  const handleAddNewUniqueness = () => {
    setUniqueness([
      ...uniqueness,
      {
        svgIcon: "",
        heading: "",
      },
    ]);
  };

  const handleAddNewMobileTripDetailBgImg = () => {
    setMobileTripDetailBgImg([...mobileTripDetailBgImg, ""]);
  };

  // Handle changes for array fields
  const handleTagChange = (index, value) => {
    const newTags = [...tags];
    newTags[index] = value;
    setTags(newTags);
  };

  const handleInclusionChange = (index, value) => {
    const newInclusion = [...inclusions];
    newInclusion[index] = value;
    setInclusions(newInclusion);
  };

  const handleExclusionChange = (index, value) => {
    const newExclusion = [...exclusions];
    newExclusion[index] = value;
    setExclusions(newExclusion);
  };

  const handleGalleryImageChange = (index, value) => {
    const newGallery = [...gallery];
    newGallery[index] = value;
    setGallery(newGallery);
  };

  const handleQuickDetailChange = (index, field, value) => {
    const newQuickDetails = [...quickDetails];
    newQuickDetails[index][field] = value;
    setQuickDetails(newQuickDetails);
  };

  const handleItineraryItemChange = (index, field, value) => {
    const newItinerary = [...itinerary];
    newItinerary[index][field] = value;
    setItinerary(newItinerary);
  };

  const handleAddItineraryDesc = (itemIndex) => {
    const newItinerary = [...itinerary];
    newItinerary[itemIndex].desc.push("");
    setItinerary(newItinerary);
  };

  const handleItineraryDescChange = (itemIndex, descIndex, value) => {
    const newItinerary = [...itinerary];
    newItinerary[itemIndex].desc[descIndex] = value;
    setItinerary(newItinerary);
  };

  const handleRemoveItineraryDesc = (itemIndex, descIndex) => {
    const newItinerary = [...itinerary];
    newItinerary[itemIndex].desc.splice(descIndex, 1);
    setItinerary(newItinerary);
  };

  const handleDateRangeChange = (index, range) => {
    const dates = [...selectedDates];
    dates[index].from = range?.from;
    dates[index].to = range?.to;
    setSelectedDates(dates);
  };

  const handleDateRangeTripTitleChange = (index, e) => {
    const dates = [...selectedDates];
    dates[index].tripTitleLine = e.target.value;
    setSelectedDates(dates);
  };

  const handleTripOverviewChange = (index, obj) => {
    const newTripOverview = [...tripOverview];
    newTripOverview[index] = {
      ...newTripOverview[index],
      ...obj,
    };
    setTripOverview(newTripOverview);
  };

  const handleTripStaysChange = (index, obj) => {
    const newTripStays = [...tripStays];
    newTripStays[index] = {
      ...newTripStays[index],
      ...obj,
    };
    setTripStays(newTripStays);
  };

  const handleVibeGalleryChange = (index, obj) => {
    const newVibeGallery = [...vibeGallery];
    newVibeGallery[index] = obj;
    setVibeGallery(newVibeGallery);
  };

  const handleUniquenessChange = (index, obj) => {
    const newUniqueness = [...uniqueness];
    newUniqueness[index] = {
      ...newUniqueness[index],
      ...obj,
    };
    setUniqueness(newUniqueness);
  };

  const handleLocationChange = (e) => {
    setLocation(e.target.value);
  };

  const onTripStatusSelected = (status) => {
    setTripStatus(status);
  };

  const onInfluencerSelected = (influencerId) => {
    const foundInfluencer = influencers.find(
      (influencer) => influencer.id === influencerId
    );
    setSelectedInfluencer({
      key: foundInfluencer.id,
      value: foundInfluencer.fullName,
    });
  };

  const handlePriceChange = (e) => {
    setPrice(parseFloat(e.target.value));
  };

  const handleBookingAmountChange = (e) => {
    setBookingAmount(parseFloat(e.target.value));
  }

  const handleCardImgChange = (e) => {
    setCardImg(e.target.value);
  };

  const handleTripDetailBgImgChange = (e) => {
    setTripDetailBgImg(e.target.value);
  };

  const handleTripCategoryChange = (e) => {
    setTripCategory(e.target.value);
  };

  const handleTripCategoryImgChange = (e) => {
    setTripCategoryImg(e.target.value);
  };

  const handleVacancyChange = (e) => {
    setVacancy(e.target.value);
  };

  const handleVacancyBackgroundChange = (e) => {
    setVacancyBackground(e.target.value);
  };

  const handleTripNameChange = (e) => {
    setTripName(e.target.value);
  };

  const handleTripIdAliasChange = (e) => {
    setTripIdAlias(e.target.value);
  };

  const handleTripTitleLineChange = (e) => {
    setTripTitleLine(e.target.value);
  };

  const handleTripPriceLineChange = (e) => {
    setTripPriceLine(e.target.value);
  };

  const handleCuratorLineChange = (e) => {
    setCuratorLine(e.target.value);
  };

  const handleCuratorImgChange = (e) => {
    setCuratorImg(e.target.value);
  };

  const handleCuratorBgImgChange = (e) => {
    setCuratorBgImg(e.target.value);
  };

  const handleRefundPolicyImgChange = (e) => {
    setRefundPolicyImg(e.target.value);
  };

  const handleTripDescriptionChange = (e) => {
    setTripDescription(e.target.value);
  };

  const handleMobileTripDetailBgImgChange = (index, value) => {
    const newMobileTripDetailBgImg = [...mobileTripDetailBgImg];
    newMobileTripDetailBgImg[index] = value;
    setMobileTripDetailBgImg(newMobileTripDetailBgImg);
  };

  const handleRemoveTag = (index) => {
    const newTags = [...tags];
    newTags.splice(index, 1);
    setTags(newTags);
  };

  const handleRemoveInclusion = (index) => {
    const newInclusions = [...inclusions];
    newInclusions.splice(index, 1);
    setInclusions(newInclusions);
  };

  const handleRemoveExclusion = (index) => {
    const newExclusions = [...exclusions];
    newExclusions.splice(index, 1);
    setExclusions(newExclusions);
  };

  const handleRemoveGalleryImage = (index) => {
    const newGallery = [...gallery];
    newGallery.splice(index, 1);
    setGallery(newGallery);
  };

  const handleRemoveQuickDetail = (index) => {
    const newQuickDetails = [...quickDetails];
    newQuickDetails.splice(index, 1);
    setQuickDetails(newQuickDetails);
  };

  const handleRemoveItineraryItem = (index) => {
    const newItinerary = [...itinerary];
    newItinerary.splice(index, 1);
    setItinerary(newItinerary);
  };

  const handleRemoveDate = (index) => {
    const newDates = [...selectedDates];
    newDates.splice(index, 1);
    setSelectedDates(newDates);
  };

  const handleRemoveTripOverview = (index) => {
    const newTripOverview = [...tripOverview];
    newTripOverview.splice(index, 1);
    setTripOverview(newTripOverview);
  };

  const handleRemoveTripStays = (index) => {
    const newTripStays = [...tripStays];
    newTripStays.splice(index, 1);
    setTripStays(newTripStays);
  };

  const handleRemoveVibeGallery = (index) => {
    const newVibeGallery = [...vibeGallery];
    newVibeGallery.splice(index, 1);
    setVibeGallery(newVibeGallery);
  };

  const handleRemoveUniqueness = (index) => {
    const newUniqueness = [...uniqueness];
    newUniqueness.splice(index, 1);
    setUniqueness(newUniqueness);
  };

  const handleRemoveMobileTripDetailBgImg = (index) => {
    const newMobileTripDetailBgImg = [...mobileTripDetailBgImg];
    newMobileTripDetailBgImg.splice(index, 1);
    setMobileTripDetailBgImg(newMobileTripDetailBgImg);
  };

  const onSaveClicked = () => {
    onSaveTripClicked(createTripDto, false);
  };

  const onCloneTripClicked = () => {
    const tripDto = createTripDto.copy({ id: "" });
    onSaveTripClicked(tripDto, true);
  };

  const getDateFooter = (range) => {
    let footer = <p>Please pick the first day.</p>;
    if (range?.from) {
      if (!range.to) {
        footer = <p>{format(range.from, "PPP")}</p>;
      } else if (range.to) {
        footer = (
          <p>
            {format(range.from, "PPP")}–{format(range.to, "PPP")}
          </p>
        );
      }
    }
    return footer;
  };

  const getDateLabel = (range) => {
    let footer = <p>Pick a date</p>;
    if (range?.from) {
      if (!range.to) {
        footer = <p>{format(range.from, "PPPP")}</p>;
      } else if (range.to) {
        footer = (
          <p>
            {format(range.from, "PPPP")}–{format(range.to, "PPPP")}
          </p>
        );
      }
    }
    return footer;
  };

  if (showLoader) {
    return (
      <>
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
          <div
            className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          ></div>
          <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
            Loading ...
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <main className="container px-4 py-8 md:px-8">
        <h1 className="text-3xl font-bold tracking-tighter sm:text-5xl mb-4">
          Create a trip
        </h1>
        <Card>
          <CardHeader>
            <CardTitle>Trip Details</CardTitle>
            <CardDescription>
              Fill in the details of your trip. Click save when you're done.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {/* Trip Name */}
            <div className="space-y-2">
              <Label htmlFor="trip-name">Trip Name</Label>
              <Input
                id="trip-name"
                placeholder="Enter trip name"
                defaultValue={tripName}
                onChange={handleTripNameChange}
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="trip-name">Trip Id Alias</Label>
              <Input
                id="trip-id-alias"
                placeholder="Enter trip Id Alias"
                defaultValue={tripIdAlias}
                onChange={handleTripIdAliasChange}
              />
            </div>

            {/* Price */}
            <div className="space-y-2">
              <Label htmlFor="price">Price</Label>
              <Input
                id="price"
                type="number"
                placeholder="Enter price"
                defaultValue={price}
                onChange={handlePriceChange}
              />
            </div>

            {/* Booking Amount */}
            <div className="space-y-2">
              <Label htmlFor="booking amount">Booking Amount</Label>
              <Input
                id="booking-amount"
                type="number"
                placeholder="Enter Booking Amount"
                defaultValue={bookingAmount}
                onChange={handleBookingAmountChange}
              />
            </div>

            {/* Card Image */}
            <div className="space-y-2">
              <Label htmlFor="card-img">Card Image</Label>
              <Input
                id="card-img"
                placeholder="Enter card image URL"
                defaultValue={cardImg}
                onChange={handleCardImgChange}
              />
            </div>

            {/* Trip Detail Background Image */}
            <div className="space-y-2">
              <Label htmlFor="card-img">Trip background Image on Detail</Label>
              <Input
                id="card-img"
                placeholder="Enter card image URL"
                defaultValue={tripDetailBgImg}
                onChange={handleTripDetailBgImgChange}
              />
            </div>

            {/* Mobile Trip Detail Background Image */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="mobile-card-img">
                  Mobile Trip background Image on Detail
                </Label>
                <Button
                  onClick={handleAddNewMobileTripDetailBgImg}
                  variant="outline"
                >
                  +
                </Button>
              </div>
              {mobileTripDetailBgImg.map((img, index) => (
                <div className="flex space-x-2">
                  <Input
                    id={`mobie-card-img-${index}`}
                    placeholder="Enter card image URL"
                    defaultValue={img}
                    onChange={(e) => {
                      handleMobileTripDetailBgImgChange(index, e.target.value);
                    }}
                  />
                  <Button
                    onClick={() => handleRemoveMobileTripDetailBgImg(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>

            {/* Trip Category */}
            <div className="space-y-2">
              <Label htmlFor="trip-category">Trip Category</Label>
              <Input
                id="trip-category"
                placeholder="Enter trip category"
                defaultValue={tripCategory}
                onChange={handleTripCategoryChange}
              />
            </div>

            {/* Trip Category Image */}
            <div className="space-y-2">
              <Label htmlFor="trip-category-img">Trip Category Image</Label>
              <Input
                id="trip-category-img"
                placeholder="Enter trip category image URL"
                defaultValue={tripCategoryImg}
                onChange={handleTripCategoryImgChange}
              />
            </div>

            {/* Vacancy */}
            <div className="space-y-2">
              <Label htmlFor="vacancy">Vacancy</Label>
              <Input
                id="vacancy"
                placeholder="Enter vacancy"
                defaultValue={vacancy}
                onChange={handleVacancyChange}
              />
            </div>

            {/* Vacancy Background */}
            <div className="space-y-2">
              <Label htmlFor="vacancy-background">Vacancy Background</Label>
              <Input
                id="vacancy-background"
                placeholder="Enter vacancy background URL"
                defaultValue={vacancyBackground}
                onChange={handleVacancyBackgroundChange}
              />
            </div>

            {/* Trip Title Line */}
            <div className="space-y-2">
              <Label htmlFor="trip-title-line">Trip Title Line</Label>
              <Input
                id="trip-title-line"
                placeholder="Enter trip title line"
                defaultValue={tripTitleLine}
                onChange={handleTripTitleLineChange}
              />
            </div>

            {/* Trip Price Line */}
            <div className="space-y-2">
              <Label htmlFor="trip-price-line">Trip Price Line</Label>
              <Input
                id="trip-price-line"
                placeholder="Enter trip price line"
                defaultValue={tripPriceLine}
                onChange={handleTripPriceLineChange}
              />
            </div>

            {/* Inluencer selection */}
            <div className="space-y-2">
              <Label htmlFor="trip-influencer">Influencer</Label>
              <Select
                className="w-full p-2 border rounded-md"
                id="select-trip-influencer"
                onValueChange={onInfluencerSelected}
                defaultValue={selectedInfluencer.key}
                value={selectedInfluencer.key}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Pick Influencer" />
                </SelectTrigger>
                <SelectContent>
                  {influencers.map((influencer, index) => (
                    <SelectItem key={index} value={influencer.id}>
                      {influencer.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Curator Line */}
            <div className="space-y-2">
              <Label htmlFor="curator-line">Curator Line</Label>
              <Input
                id="curator-line"
                placeholder="Enter curator line"
                value={curatorLine}
                onChange={handleCuratorLineChange}
              />
            </div>

            {/* Curator Image */}
            <div className="space-y-2">
              <Label htmlFor="curator-img">Curator Image</Label>
              <Input
                id="curator-img"
                placeholder="Enter curator image URL"
                value={curatorImg}
                onChange={handleCuratorImgChange}
              />
            </div>

            {/* Curator Image */}
            <div className="space-y-2">
              <Label htmlFor="curator-img">Curator Backgraound Image</Label>
              <Input
                id="curator-img"
                placeholder="Enter curator background image URL"
                value={curatorBgImg}
                onChange={handleCuratorBgImgChange}
              />
            </div>

            {/* Refund Policy Image */}
            <div className="space-y-2">
              <Label htmlFor="refund-policy-img">Refund Policy Image</Label>
              <Input
                id="refund-policy-img"
                placeholder="Enter refund policy image URL"
                value={refundPolicyImg}
                onChange={handleRefundPolicyImgChange}
              />
            </div>

            {/* Trip Stays (Hotel image , name and desc) */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="tags">Trip Stays</Label>
                <Button onClick={handleAddNewTripStays} variant="outline">
                  +
                </Button>
              </div>
              {tripStays.map((stay, index) => (
                <div key={index} className="flex space-x-2">
                  <Input
                    id={`trip-stay-img-${index}`}
                    value={stay.stayImg}
                    placeholder="Stay Image URL"
                    onChange={(e) =>
                      handleTripStaysChange(index, { stayImg: e.target.value })
                    }
                  />
                  <Input
                    id={`trip-stay-heading-${index}`}
                    value={stay.stayName}
                    placeholder="Stay Name"
                    onChange={(e) =>
                      handleTripStaysChange(index, { stayName: e.target.value })
                    }
                  />
                  <Input
                    id={`trip-stay-desc-${index}`}
                    value={stay.stayDesc}
                    placeholder="Stay Description"
                    onChange={(e) =>
                      handleTripStaysChange(index, { stayDesc: e.target.value })
                    }
                  />
                  <Button
                    onClick={() => handleRemoveTripStays(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>

            {/* Trip Overview (short details , days , no. of places) */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="tags">Trip Overview</Label>
                <Button onClick={handleAddNewTripOverview} variant="outline">
                  +
                </Button>
              </div>
              {tripOverview.map((overview, index) => (
                <div key={index} className="flex flex-col space-y-2">
                  <Select
                    className="w-full p-2 border rounded-md"
                    id={`select-svg-icon-${index}`}
                    onValueChange={(e) => {
                      handleTripOverviewChange(index, { svgIcon: e });
                    }}
                    defaultValue={overview.svgIcon}
                    value={overview.svgIcon}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Pick SVG" />
                    </SelectTrigger>
                    <SelectContent>
                      {svgList.map((svg, index) => (
                        <SelectItem key={index} value={svg.svgCode}>
                          <div className="flex flex-row w-[50vw] lg:w-[80vw] justify-between">
                            <p>{svg.svgLabel}</p>
                            {
                              <SvgHtmlPassing
                                content={svg.svgCode}
                                className="w-6 h-6"
                              />
                            }
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <Input
                    id={`trip-overview-heading-${index}`}
                    value={overview.svgHeading}
                    placeholder="Enter Heading for Svg"
                    onChange={(e) =>
                      handleTripOverviewChange(index, {
                        svgHeading: e.target.value,
                      })
                    }
                  />
                  <Input
                    id={`trip-overview-desc-${index}`}
                    value={overview.svgDesc}
                    placeholder="Enter Svg description"
                    onChange={(e) =>
                      handleTripOverviewChange(index, {
                        svgDesc: e.target.value,
                      })
                    }
                  />
                  <Button
                    onClick={() => handleRemoveTripOverview(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>

            {/* Uniquenesses of facilities provided at trip */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="tags">The Uniqueness</Label>
                <Button onClick={handleAddNewUniqueness} variant="outline">
                  +
                </Button>
              </div>
              {uniqueness.map((unique, index) => (
                <div key={index} className="flex flex-col space-y-2">
                  <Select
                    className="w-full p-2 border rounded-md"
                    id={`select-uniqueness-svg-icon-${index}`}
                    onValueChange={(e) => {
                      handleUniquenessChange(index, { svgIcon: e });
                    }}
                    defaultValue={unique.svgIcon}
                    value={unique.svgIcon}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Pick SVG" />
                    </SelectTrigger>
                    <SelectContent>
                      {svgList.map((svg, index) => (
                        <SelectItem key={index} value={svg.svgCode}>
                          <div className="flex flex-row w-[50vw] lg:w-[80vw] justify-between">
                            <p>{svg.svgLabel}</p>
                            {
                              <SvgHtmlPassing
                                content={svg.svgCode}
                                className="w-6 h-6"
                              />
                            }
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <Input
                    id={`uniqueness-heading-${index}`}
                    value={unique.heading}
                    placeholder="Enter Heading for Svg"
                    onChange={(e) =>
                      handleUniquenessChange(index, { heading: e.target.value })
                    }
                  />
                  <Button
                    onClick={() => handleRemoveUniqueness(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>

            {/* Location of the trip */}
            <div className="space-y-2">
              <Label htmlFor="location-details">Enter location of Trip</Label>
              <Input
                id="location-input"
                placeholder="Enter Location of Trip"
                value={location}
                onChange={handleLocationChange}
              />
            </div>

            {/* Vibe Gallery (Galler of Images ) */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="tags">Vibe Gallery</Label>
                <Button onClick={handleAddNewVibeGallery} variant="outline">
                  +
                </Button>
              </div>
              {vibeGallery.map((gallery, index) => (
                <div key={index} className="flex space-x-2">
                  <Input
                    id={`vibe-gallery-${index}`}
                    value={gallery}
                    placeholder="Enter Image URL"
                    onChange={(e) =>
                      handleVibeGalleryChange(index, e.target.value)
                    }
                  />
                  <Button
                    onClick={() => handleRemoveVibeGallery(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>

            <div className="space-y-2">
              <Label htmlFor="trip-description">Trip Description</Label>
              <Textarea
                id="trip-description"
                placeholder="Describe your trip"
                value={tripDescription}
                onChange={handleTripDescriptionChange}
              />
            </div>
            {/* Trip status selection */}
            <div className="space-y-2">
              <Label htmlFor="trip-influencer">Trip Status</Label>
              <Select
                className="w-full p-2 border rounded-md"
                id="select-trip-influencer"
                onValueChange={onTripStatusSelected}
                value={tripStatus}
                defaultValue={tripStatus}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Pick Status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="live">Live</SelectItem>
                  <SelectItem value="paused">Paused</SelectItem>
                  <SelectItem value="ended">Ended</SelectItem>
                </SelectContent>
              </Select>
            </div>
            {/* Tags */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="tags">Tags</Label>
                <Button onClick={handleAddTag} variant="outline">
                  +
                </Button>
              </div>
              {tags.map((tag, index) => (
                <div key={index} className="flex space-x-2">
                  <Input
                    id={`tags-${index}`}
                    value={tag}
                    placeholder="Enter tag"
                    onChange={(e) => handleTagChange(index, e.target.value)}
                  />
                  <Button
                    onClick={() => handleRemoveTag(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>
            {/* Inclusions */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="inclusions">Inclusions</Label>
                <Button onClick={handleAddInclusion} variant="outline">
                  +
                </Button>
              </div>
              {inclusions.map((inclusion, index) => (
                <div key={index} className="flex space-x-2">
                  <Input
                    id={`inclusions-${index}`}
                    value={inclusion}
                    placeholder="Enter Inclusion"
                    onChange={(e) =>
                      handleInclusionChange(index, e.target.value)
                    }
                  />
                  <Button
                    onClick={() => handleRemoveInclusion(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>
            {/* Exclusions */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="exclusions">Exclusions</Label>
                <Button onClick={handleAddExclusion} variant="outline">
                  +
                </Button>
              </div>
              {exclusions.map((exclusion, index) => (
                <div key={index} className="flex space-x-2">
                  <Input
                    id={`exclusions-${index}`}
                    value={exclusion}
                    placeholder="Enter Exclusion"
                    onChange={(e) =>
                      handleExclusionChange(index, e.target.value)
                    }
                  />
                  <Button
                    onClick={() => handleRemoveExclusion(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>

            {/* Gallery */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="gallery">Gallery</Label>
                <Button onClick={handleAddGalleryImage} variant="outline">
                  +
                </Button>
              </div>
              {gallery.map((image, index) => (
                <div key={index} className="flex space-x-2">
                  <Input
                    id={`gallery-${index}`}
                    value={image}
                    placeholder="Enter image URL"
                    onChange={(e) =>
                      handleGalleryImageChange(index, e.target.value)
                    }
                  />
                  <Button
                    onClick={() => handleRemoveGalleryImage(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>

            {/* Quick Details */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="quick-details">Quick Details</Label>
                <Button onClick={handleAddQuickDetail} variant="outline">
                  +
                </Button>
              </div>
              {quickDetails.map((detail, index) => (
                <div key={index} className="space-y-2">
                  <Input
                    id={`quick-details-title-${index}`}
                    value={detail.itemTitle}
                    placeholder="Title"
                    onChange={(e) =>
                      handleQuickDetailChange(
                        index,
                        "itemTitle",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    id={`quick-details-desc-${index}`}
                    value={detail.itemDesc}
                    placeholder="Description"
                    onChange={(e) =>
                      handleQuickDetailChange(index, "itemDesc", e.target.value)
                    }
                  />
                  <Input
                    id={`quick-details-img-${index}`}
                    value={detail.itemImg}
                    placeholder="Image URL"
                    onChange={(e) =>
                      handleQuickDetailChange(index, "itemImg", e.target.value)
                    }
                  />
                  <Button
                    onClick={() => handleRemoveQuickDetail(index)}
                    variant="outline"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>

            {/* Itinerary */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="itinerary">Itinerary</Label>
                <Button onClick={handleAddItineraryItem} variant="outline">
                  +
                </Button>
              </div>
              {itinerary.map((item, index) => (
                <div key={index} className="space-y-2">
                  <Input
                    id={`itinerary-heading-${index}`}
                    value={item.heading}
                    placeholder="Heading"
                    onChange={(e) =>
                      handleItineraryItemChange(
                        index,
                        "heading",
                        e.target.value
                      )
                    }
                  />
                  <Button
                    onClick={() => handleAddItineraryDesc(index)}
                    variant="outline"
                  >
                    Add Description
                  </Button>
                  {item.desc.map((desc, descIndex) => (
                    <div key={descIndex} className="flex space-x-2">
                      <Textarea
                        id={`itinerary-desc-${index}-${descIndex}`}
                        value={desc}
                        placeholder="Description"
                        onChange={(e) =>
                          handleItineraryDescChange(
                            index,
                            descIndex,
                            e.target.value
                          )
                        }
                      />
                      <Button
                        onClick={() =>
                          handleRemoveItineraryDesc(index, descIndex)
                        }
                        variant="outline"
                      >
                        Remove
                      </Button>
                    </div>
                  ))}
                  <Input
                    id={`itinerary-img-${index}`}
                    value={item.img}
                    placeholder="Image URL"
                    onChange={(e) =>
                      handleItineraryItemChange(index, "img", e.target.value)
                    }
                  />
                  <Button
                    onClick={() => handleRemoveItineraryItem(index)}
                    variant="outline"
                  >
                    Remove Entire Itinerary
                  </Button>
                </div>
              ))}
            </div>
            {/* Trip Date Range */}
            <div className="grid gap-2">
              <div className="flex items-center space-x-2">
                <Label htmlFor="date">Trip Start and End Dates</Label>
                <Button onClick={handleAddNewDate} variant="outline">
                  +
                </Button>
              </div>
              {selectedDates.map((dateRange, index) => (
                <div className="flex flex-col space-y-2 mb-6">
                  <Popover key={index}>
                    <PopoverTrigger asChild>
                      <div className="flex space-x-2">
                        <Button
                          className="w-full justify-start text-left font-normal"
                          id="date"
                          variant="outline"
                        >
                          <CalendarDaysIcon className="mr-1 h-4 w-4 -translate-x-1" />
                          {getDateLabel(dateRange)}
                        </Button>
                        <Button
                          onClick={() => handleRemoveDate(index)}
                          variant="outline"
                        >
                          Remove
                        </Button>
                      </div>
                    </PopoverTrigger>
                    <PopoverContent align="start" className="w-auto p-0">
                      <Calendar
                        mode="range"
                        numberOfMonths={2}
                        selected={dateRange}
                        onSelect={(range) => {
                          handleDateRangeChange(index, range);
                        }}
                        footer={getDateFooter(dateRange)}
                      />
                    </PopoverContent>
                  </Popover>
                  <Input
                    id={`trip-title-line-for-date-range-${index}`}
                    value={dateRange.tripTitleLine}
                    placeholder="Enter Trip Title Line for this date range"
                    onChange={(e) => handleDateRangeTripTitleChange(index, e)}
                  />
                </div>
              ))}
            </div>
          </CardContent>
          <div className="flex">
            <CardFooter>
              <Button onClick={onSaveClicked}>{saveButtonLabel}</Button>
            </CardFooter>
            {canShowCloneButton && (
              <CardFooter>
                <Button onClick={onCloneTripClicked}>Clone Trip</Button>
              </CardFooter>
            )}
          </div>
        </Card>
        <Toaster />
      </main>
    </>
  );
};

function CalendarDaysIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
      <line x1="16" x2="16" y1="2" y2="6" />
      <line x1="8" x2="8" y1="2" y2="6" />
      <line x1="3" x2="21" y1="10" y2="10" />
      <path d="M8 14h.01" />
      <path d="M12 14h.01" />
      <path d="M16 14h.01" />
      <path d="M8 18h.01" />
      <path d="M12 18h.01" />
      <path d="M16 18h.01" />
    </svg>
  );
}

export default AdminCreateTripView;
